var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.media
    ? _c(
        "div",
        [
          _vm.video
            ? _c("videoplayer", {
                attrs: {
                  src: _vm.video,
                  poster: _vm.poster,
                  edit: true,
                  chapters: _vm.chapters
                },
                on: {
                  seek: function($event) {
                    _vm.$parent.playTime = $event
                  },
                  duration: function($event) {
                    _vm.$parent.duration = $event
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.video2
            ? _c("videoplayer", {
                attrs: {
                  src: _vm.video2,
                  poster: _vm.poster,
                  edit: true,
                  chapters: _vm.chapters
                },
                on: {
                  seek: function($event) {
                    _vm.$parent.playTime = $event
                  },
                  duration: function($event) {
                    _vm.$parent.duration = $event
                  }
                }
              })
            : _vm.photo
            ? _c("div", { staticClass: "tv-inner" }, [
                _c("div", { staticClass: "video-container" }, [
                  _c("img", { attrs: { src: _vm.photo } })
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "remove",
              attrs: { href: "" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.$emit("delete")
                }
              }
            },
            [_vm._v("×")]
          )
        ],
        1
      )
    : _c("div", [
        _vm.mode == null
          ? _c("div", { staticClass: "video-uploader" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("input", {
                ref: "filechooser",
                attrs: { type: "file" },
                on: { change: _vm.uploadFile }
              })
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.mode == null
          ? _c(
              "div",
              {
                staticClass: "video-uploader video-up-2",
                on: {
                  click: function($event) {
                    _vm.uploadedListShown = true
                  }
                }
              },
              [
                _vm._m(1),
                _vm._v(" "),
                _vm.uploadedListShown
                  ? _c("form", [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.uploadedVideo,
                              expression: "uploadedVideo"
                            }
                          ],
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.uploadedVideo = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            }
                          }
                        },
                        _vm._l(_vm.uploadedVideos, function(vid) {
                          return _c("option", { domProps: { value: vid } }, [
                            _vm._v(
                              _vm._s("" && vid.index) + " " + _vm._s(vid.name)
                            )
                          ])
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.selectVideo($event)
                            }
                          }
                        },
                        [_vm._v("Select")]
                      )
                    ])
                  : _vm._e()
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.mode == "uploading"
          ? _c("div", { staticClass: "upload-progress" }, [
              _c("div", {
                staticClass: "progress-bar",
                style: { width: _vm.progress * 100 + "%" }
              }),
              _vm._v(" "),
              _c("label", [
                _vm._v(
                  "Uploading " +
                    _vm._s(
                      _vm.progress !== null
                        ? Math.round(_vm.progress * 100) + "%"
                        : ""
                    )
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.mode == "processing"
          ? _c("div", { staticClass: "upload-progress" }, [
              _c("div", {
                staticClass: "progress-bar",
                style: { width: _vm.progress * 100 + "%" }
              }),
              _vm._v(" "),
              _c("label", [
                _vm._v(
                  "Processing " +
                    _vm._s(
                      _vm.progress !== null
                        ? Math.round(_vm.progress * 100) + "%"
                        : ""
                    )
                )
              ])
            ])
          : _vm._e()
      ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _vm._v("Drag and drop video here "),
      _c("span"),
      _vm._v(" or click to select video")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_vm._v("select uploaded video "), _c("span")])
  }
]
render._withStripped = true

export { render, staticRenderFns }